import React, { useEffect, useState, useContext } from "react";
import SidePanelElementCard from "./SidePanelElementCard";
import SidePanelChildElement from "./SidePanelChildElement";
import { SB3RuleContext } from "../Rules/SB3RuleContext";
import {RANGE_FIELD} from "../../ISRConstants";
type TSidePanelElementProps = {
    item: any;
    searchTerm: string;
    searchChoice: boolean
};


const SidePanelElement = ({ item, searchChoice, searchTerm }: TSidePanelElementProps) => {
    const { selectedObj } = useContext(SB3RuleContext);
    const [expanded, setExpanded] = useState(false);
    useEffect(() => {
        setExpanded(false)
    }, [selectedObj, searchChoice])

    useEffect(() => {
        searchTerm ? setExpanded(true) : setExpanded(false)
    }, [searchTerm])
    return (
        <>
            <SidePanelElementCard submodel={item.submodel} field={item.id} item={item} expanded={expanded} setExpanded={setExpanded} />
            {expanded &&
                item?.fields &&
                item?.fields?.map((field: any, fieldIndex: number) => {
                    // if(field.type === RANGE_FIELD.toLowerCase()) return <></>
                    return (
                        <SidePanelChildElement key={fieldIndex} item={field} keyName="choices" searchChoice={searchChoice} searchTerm={searchTerm} />
                    );
                })}

            {expanded &&
                item?.categories &&
                item?.categories?.map((category: any, categoryIndex: number) => {

                    return (
                        <SidePanelChildElement key={categoryIndex} item={category} keyName="categories" searchChoice={searchChoice} searchTerm={searchTerm} />
                    )
                })}

        </>
    );
};

export default SidePanelElement;
